import React, { Component } from "react";
import UserProfilePicturePlaceHolderJPEG from "../../../../Assets/jpeg/UserProfilePicturePlaceHolderJPEG.jpg";
import SettingsIconSVG from "../../../../Assets/svg/SettingsIconSVG.svg";
import CollapseWindowBottonSVG from "../../../../Assets/svg/CollapseWindowBottonSVG.svg";
import CESSVG from "../../../../Assets/svg/CESSVG.svg";
import DotsThreeSVG from "../../../../Assets/svg/DotsThreeSVG.svg";
import ChatTeardropDotsSVG from "../../../../Assets/svg/ChatTeardropDotsSVG.svg";
import {
  FetchChatSessionsAction,
  FetchIndividualChatSessionAction,
  ContinueChatSessionAddSessionIDToReduxAction,
  resetContinueChatSessionAction,
  DeleteChatSessionAction,
  ResetIsNewChatSession,
  RenameChatSessionAction,
} from "../../../../Actions/AI";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";
import TrashSVG from "../../../../Assets/svg/TrashSVG.svg";
import PencilSVG from "../../../../Assets/svg/PencilSimpleSVG.svg";
import { CollapseCX2SidebarInactiveAction } from "../../../../Actions/Interactions";

class AIChatBotSideBar extends Component {
  static propTypes = {
    FetchChatSessionsAction: PropTypes.func.isRequired,
    FetchIndividualChatSessionAction: PropTypes.func.isRequired,
    ContinueChatSessionAddSessionIDToReduxAction: PropTypes.func.isRequired,
    SideBarchatSessions: PropTypes.array,
    SideBarchatSessionsFetchSuccess: PropTypes.bool,
    navigate: PropTypes.func.isRequired,
    resetContinueChatSessionAction: PropTypes.func.isRequired,
    ResetIsNewChatSession: PropTypes.func.isRequired,
    DeleteChatSessionAction: PropTypes.func.isRequired,
    RenameChatSessionAction: PropTypes.func.isRequired,
    user: PropTypes.object,
    toggleSidebar: PropTypes.func.isRequired,
    CollapseCX2SidebarInactiveAction: PropTypes.func.isRequired,
  };

  state = {
    chatsessionID: null,
    showOptions: false,
    activeMenuId: null,
    editingSessionId: null,
    editingTitle: "",
  };

  componentDidMount() {
    // Fetch chat sessions when the component mounts
    this.props.FetchChatSessionsAction();
  }

  handleContinueChat = (sessionId) => {
    this.props.FetchIndividualChatSessionAction(sessionId);
    this.props.ContinueChatSessionAddSessionIDToReduxAction(sessionId);
    this.props.navigate(`/dashboard/ai-models/ai-chatbot/${sessionId}`);
    this.props.ResetIsNewChatSession();
  };

  handleStartNewChat = () => {
    this.props.resetContinueChatSessionAction();
    this.props.navigate("/dashboard/ai-models/ai-chatbot");
  };

  handleDeleteChatSession = (sessionId) => {
    // Extract the ID from the current path
    const currentPathId = this.props.location?.pathname?.split("/").pop();

    // Call the delete action and wait for it to complete
    this.props.DeleteChatSessionAction(sessionId).then(() => {
      // Fetch updated chat sessions after deletion
      this.props.FetchChatSessionsAction();

      // Clear the active menu state
      this.setState({ activeMenuId: null });

      // If the current path matches the session being deleted, navigate to a new path
      if (currentPathId === sessionId.toString()) {
        this.props.navigate("/dashboard/ai-chatbot");
      }
    });
  };

  toggleMenu = (sessionId) => {
    // Toggle the menu visibility for the specific session
    this.setState((prevState) => ({
      activeMenuId: prevState.activeMenuId === sessionId ? null : sessionId,
    }));
  };

  handleCollapseDisable = () => {
    this.props.CollapseCX2SidebarInactiveAction();
  };

  handleStartRename = (sessionId, currentTitle) => {
    this.setState({
      editingSessionId: sessionId,
      editingTitle: currentTitle || "",
      activeMenuId: null,
    });
  };

  handleRenameChange = (e) => {
    this.setState({ editingTitle: e.target.value });
  };

  handleRenameSubmit = (sessionId) => {
    const { editingTitle } = this.state;
    this.props.RenameChatSessionAction(sessionId, editingTitle).then(() => {
      this.props.FetchChatSessionsAction();
      this.setState({ editingSessionId: null, editingTitle: "" });
    });
  };

  handleRenameCancel = () => {
    this.setState({ editingSessionId: null, editingTitle: "" });
  };

  handleRenameKeyDown = (e, sessionId) => {
    if (e.key === "Enter") {
      this.handleRenameSubmit(sessionId);
    } else if (e.key === "Escape") {
      this.handleRenameCancel();
    }
  };

  renderChatSessions() {
    const { SideBarchatSessions, SideBarchatSessionsFetchSuccess } = this.props;

    if (!SideBarchatSessionsFetchSuccess) {
      return <div>Loading...</div>;
    }

    if (!SideBarchatSessions || SideBarchatSessions.length === 0) {
      return <div>No chat sessions available.</div>;
    }

    // Sort sessions by started_at timestamp in descending order (most recent first)
    const sortedSessions = [...SideBarchatSessions].sort(
      (a, b) => new Date(b.started_at) - new Date(a.started_at)
    );

    return sortedSessions.map((session) => {
      // Format the start date using JavaScript's toLocaleString
      const formattedDate = new Date(session.started_at).toLocaleString(
        "en-US",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }
      );

      // Find the last message sent by the user
      const userMessages = session.messages.filter(
        (message) => message.role === "user"
      );
      const lastUserMessage =
        userMessages.length > 0
          ? userMessages[userMessages.length - 1].content
          : "No user messages yet";

      // Trim the user message to 30 characters with ellipsis if it's too long
      const trimmedMessage =
        lastUserMessage.length > 30
          ? lastUserMessage.substring(0, 30) + "..."
          : lastUserMessage;

      // Use title if available, otherwise show "New Chat"
      const displayTitle = session.title || "New Chat";
      const isEditing = this.state.editingSessionId === session.id;

      return (
        <div
          key={session.id}
          className="flex items-center gap-2 mb-2 px-3 py-2.5 rounded-lg bg-white/5 hover:bg-white/10 text-gray-200 transition-all duration-150 relative"
        >
          {isEditing ? (
            <div className="flex flex-col flex-grow">
              <input
                type="text"
                value={this.state.editingTitle}
                onChange={this.handleRenameChange}
                onKeyDown={(e) => this.handleRenameKeyDown(e, session.id)}
                onBlur={() => this.handleRenameSubmit(session.id)}
                autoFocus
                className="font-semibold text-xs bg-transparent border border-white/20 rounded px-2 py-1 text-white placeholder:text-gray-400"
                placeholder="Enter chat title..."
              />
              <div className="text-gray-400 text-[0.65rem] mt-1">
                Press Enter to save, Esc to cancel
              </div>
            </div>
          ) : (
            <button
              onClick={() => this.handleContinueChat(session.id)}
              className="flex flex-col flex-grow text-left"
            >
              <div className="font-semibold text-sm text-white">{displayTitle}</div>
              <div className="text-gray-400 text-xs">{trimmedMessage}</div>
            </button>
          )}

          {/* Three-dot button to toggle menu */}
          {!isEditing && (
            <button
              onClick={() => this.toggleMenu(session.id)}
              className="relative text-gray-400 hover:text-white"
            >
              <img src={DotsThreeSVG} alt="more options" />
            </button>
          )}

          {/* Menu with rename and delete options */}
          {this.state.activeMenuId === session.id && (
            <div className="absolute right-8 top-0 bg-[#111827] border border-white/10 shadow-lg rounded-md p-2 z-[999]">
              <button
                onClick={() => this.handleStartRename(session.id, session.title)}
                className="flex items-center gap-2 text-gray-200 hover:text-white mb-2 w-full"
              >
                <img src={PencilSVG} alt="Rename" className="w-4 h-4" />
                <span>Rename</span>
              </button>
              <button
                onClick={() => this.handleDeleteChatSession(session.id)}
                className="flex items-center gap-2 text-red-400 hover:text-red-300 w-full"
              >
                <img src={TrashSVG} alt="Delete" />
                <span>Delete</span>
              </button>
            </div>
          )}
        </div>
      );
    });
  }

  render() {
    return (
      <div className="group fixed flex flex-col w-14 hover:w-[16.625rem] h-screen bg-slate-900 border-r border-white/5 z-30 transition-[width] duration-200 ease-in-out overflow-hidden shadow-none hover:shadow-2xl">
        <div className="flex flex-col h-full px-3.5 py-5 gap-6 overflow-hidden">
          <div className="flex flex-col gap-5 border-b border-white/5 pb-4">
            {/* Header with Logo and Collapse Button */}
            <div className="flex items-center justify-between overflow-hidden">
              <div className="flex items-center gap-3 overflow-hidden">
                <div className="w-7 h-7 shrink-0 bg-white rounded-md flex items-center justify-center">
                  <img src={CESSVG} alt="CES svg logo" className="w-5 h-5" />
                </div>
                <span className="font-SFPro font-semibold text-white text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-75">
                  CX2 Chat
                </span>
              </div>
              <button
                onClick={this.handleCollapseDisable}
                className="text-gray-400 hover:text-white"
              >
                <img src={CollapseWindowBottonSVG} alt="Collapse" />
              </button>
            </div>

            {/* User Profile Section */}
            <div className="flex items-center justify-between">
              <div className="flex gap-2 items-center overflow-hidden">
                <img
                  src={UserProfilePicturePlaceHolderJPEG}
                  alt="user profile picture"
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div className="flex flex-col">
                  <div className="font-inter font-medium text-sm text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-75">
                    {this.props.user?.first_name} {this.props.user?.last_name}
                  </div>
                  <div className="text-[0.65rem] text-gray-400 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-75">
                    Active sessions & history
                  </div>
                </div>
              </div>
              <button className="text-gray-400 hover:text-white">
                <img src={SettingsIconSVG} alt="Settings Icon" />
              </button>
            </div>
          </div>

          {/* Chat Sessions */}
          <div className="flex flex-col flex-1 gap-3 min-h-0">
            <div className="flex flex-col gap-2">
              <div className="font-inter font-semibold text-xs tracking-wide text-gray-300 uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-75">
                Chat Sessions
              </div>
              <div className="flex flex-col gap-1 max-h-full overflow-x-hidden overflow-y-auto pr-1">
                {this.renderChatSessions()}
              </div>
            </div>

            {/* Start New Chat Button */}
            <button
              onClick={this.handleStartNewChat}
              className="mt-auto flex justify-center items-center bg-gradient-to-r w-full h-11 from-[#5FA731] to-[#4D8F22] rounded-lg gap-2 text-sm font-medium text-white hover:shadow-md hover:brightness-105 transition-all duration-150"
            >
              <img src={ChatTeardropDotsSVG} alt="Start new chat" className="w-4 h-4" />
              <span className="whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-75">
                Start New Chat
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SideBarchatSessions: state.ai.SideBarchatSessions,
  SideBarchatSessionsFetchSuccess: state.ai.SideBarchatSessionsFetchSuccess,
  user: state.authentication.user,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    FetchChatSessionsAction,
    FetchIndividualChatSessionAction,
    ContinueChatSessionAddSessionIDToReduxAction,
    resetContinueChatSessionAction,
    DeleteChatSessionAction,
    ResetIsNewChatSession,
    RenameChatSessionAction,
    CollapseCX2SidebarInactiveAction,
  })(AIChatBotSideBar)
);
